module.exports = __webpack_public_path__ + "media/music_33.c51aa7d8.mp3";